module.exports = __webpack_public_path__ + "static/media/swatchbook.d28d2e4f.svg";